import { render, staticRenderFns } from "./EquipmentTabs.vue?vue&type=template&id=681e8270"
import script from "./EquipmentTabs.vue?vue&type=script&lang=js"
export * from "./EquipmentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports